<div class="container" id="landing">
  <div class="row">
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 class="section-title">Dashboard</h1>
        </div>
        <div class="flex items-end justify-between gap-3"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <p>Hi, {{session.user?.username}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
